import { useContext, useEffect } from 'react';
import { Row, Column, Button } from '@simplywallst/ui-core';
import { Container } from './styled';
import { RecentUpdatesList } from './components/RecentUpdatesList';
import { SideMenuContext } from '@/components/CompanyOverview/components/SideMenu/context';

interface Props {
  lookup: string | null;
}

export function MoreUpdates(props: Props) {
  const { showMenu, setShowMenu, createSideMenu } = useContext(SideMenuContext);
  const { lookup } = props;
  useEffect(() => {
    if (showMenu && typeof createSideMenu === 'function') {
      createSideMenu(
        <RecentUpdatesList
          show={showMenu}
          lookup={lookup}
          onClose={() => {
            setShowMenu(false);
          }}
        />
      );
    }
  }, [showMenu, lookup]);
  return (
    <>
      <Row>
        <Column colMd={10} offsetMd={2}>
          <Container>
            <Button
              display="block"
              onClick={() => {
                setShowMenu(true);
              }}
              styleType="loud"
              data-cy-id="see-more-updates"
              disabled={showMenu}
            >
              See more updates
            </Button>
          </Container>
        </Column>
      </Row>
    </>
  );
}
